export default __webpack_public_path__ + "static/home-caveman-0e79dd01b1456bdcf3caad0ded91b9c3.png";